import React from "react";
import { FaFacebookF, FaInstagram, FaWhatsapp, FaGlobe } from "react-icons/fa";

function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-6">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        <div className="flex space-x-6 text-lg mb-4">
          {/* WhatsApp */}
          <a
            href="https://wa.me/0113266213"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-green-400 transition"
          >
            <FaWhatsapp />
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/_magnate_ke?utm_source=qr&igsh=MXM0eWN0d3djeW9uMw=="
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-pink-400 transition"
          >
            <FaInstagram />
          </a>

          {/* Website */}
          <a
            href="https://ndiritu.vercel.app"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-400 transition"
          >
            <FaGlobe />
          </a>

          {/* Facebook */}
          <a
            href="https://www.facebook.com/profile.php?id=100023396029642"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-600 transition"
          >
            <FaFacebookF />
          </a>
        </div>
        <p className="text-sm mb-4 md:mb-0">
          &copy; {new Date().getFullYear()} MagnateForex. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
